import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-kaza-tracker',
  imports: [PagePlaceholderComponent],
  templateUrl: './kaza-tracker.component.html',
  styleUrl: './kaza-tracker.component.scss'
})
export class KazaTrackerComponent {
  protected readonly icon = '✅';
  protected readonly pageTitle = 'pages.kaza_tracker.title';
  protected readonly subtitle = 'pages.kaza_tracker.subtitle';
}
